"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function appPaymentToApiPayment(appPayment) {
    const paidAmount = Number(appPayment.paidAmount);
    const paymentTips = Number(appPayment.paymentTips);
    return {
        id: appPayment.id,
        paymentMethod: appPayment.paymentMethod,
        paymentCharge: appPayment.paymentCharge,
        amount: appPayment.amount,
        paidAmount: paidAmount,
        paymentTips: paymentTips,
        change: paidAmount - appPayment.amount + paymentTips,
        remark: appPayment.remark,
    };
}
exports.default = appPaymentToApiPayment;
//# sourceMappingURL=appPaymentToApiPayment.js.map